import index from './form-textarea'

export default index